<template>
    <div>
      <!--<span v-if="checkEnv">
        {{hostname}}
      </span>
      <b-btn v-if="checkEnv" tile type="button" @click="disconnect">DC</b-btn>
      <b-btn v-if="checkEnv" tile type="button" @click="reconnect">RC</b-btn>-->
        <TeremHeader v-if="(gameType === 'TEREM')" :id="id" :szezonid="szezonid" :teams="teams" :statistics="statistics" :matchdate="matchdate" :venue="venue" :competition="competition" :age="age" :gender="gender" :lastPeriod="lastPeriod" :items="items"/>
        <StrandHeader v-if="(gameType === 'STRAND')" :id="id" :szezonid="szezonid" :teams="teams" :statistics="statistics" :matchdate="matchdate" :venue="venue" :competition="competition" :age="age" :gender="gender" :lastPeriod="lastPeriod"/>
    </div>
</template>

<script>
    import TeremHeader from '../components/terem/TeremHeader';
    import StrandHeader from '../components/strand/StrandHeader';

    export default {
        name: 'Header',
        components: {
            TeremHeader,
            StrandHeader
        },
        props: {
            id: String,
            szezonid: String,
            teams: Object,
            statistics: Object,
            venue: String,
            matchdate: String,
            competition: String,
            age: String,
            gender: String,
            gameType: String,
            lastPeriod: String,
            items: Array
        },
      computed: {
        hostname: function () {
          return window.location.hostname.toLowerCase();
        }
      },
      methods: {
        checkEnv() {
          const host = this.hostname

          if (
              host.startsWith("localhost") ||
              host.startsWith("dev") ||
              host.startsWith("teszt")
          ) {
            return true;
          }

          return false;
        },
        disconnect() {
          window.vueio.disconnect();
        },
        reconnect() {
          window.vueio.connect();
        },
      }
    }
</script>